export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0030.47acae68.webp";